module.exports = __webpack_public_path__ + "static/media/adsk-products working.4aaffa9a.csv";